import { render, staticRenderFns } from "./TableWrapBoolDropdown.vue?vue&type=template&id=a720ce12&"
import script from "./TableWrapBoolDropdown.vue?vue&type=script&lang=js&"
export * from "./TableWrapBoolDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports